import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteSingleAttachment } from "modules/shared/api";
import { setMessage } from "modules/shared/notification/slice";
import { Input, RejectionReason, UploadAttachments, VerifyComponent } from "components";
import { FormRow, FormGroup, Row, Textarea } from "styles/forms/main";
import { getUserRoles } from "modules/auth/slice";

function LicenseInfo({
    newTruckData,
    setNewTruckData,
    isEditable,
    selectedTruckId,
    truckAttachments,
    setTruckAttachments,
    licenseExpirationError,
    objections,
    isAuthorizedToCreate,
    isQARole,
    handleObjections,
}) {
    const [objection, setObjections] = useState({});

    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };
    const getCurrentUserRole = useSelector(getUserRoles()).filter((role) => role === "reviewer");

    const currentDate = new Date();
    const pastDate = new Date();
    const ALLOWED_NUM_OF_YEARS_BEFORE = 1;
    const ALLOWED_NUM_OF_YEARS_AFTER = 5;

    pastDate.setFullYear(currentDate.getFullYear() - ALLOWED_NUM_OF_YEARS_BEFORE);

    const futureDate = new Date();
    futureDate.setFullYear(currentDate.getFullYear() + ALLOWED_NUM_OF_YEARS_AFTER);
    const dispatch = useDispatch();

    const handleDeleteUploadedItem = (id) => {
        deleteSingleAttachment(id).then(() => {
            setTruckAttachments(truckAttachments?.filter((item) => item?.id !== id));
            dispatch(
                setMessage({
                    content: `Attachment deleted successfully`,
                    isError: false,
                })
            );
        });
    };

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };

    return (
        <>
            <FormRow>
                <FormGroup>
                    <Row>
                        <UploadAttachments
                            label="Truck Photo - Face"
                            onFilesChange={(e) => setNewTruckData({ ...newTruckData, photo: e })}
                            uploadedAttachments={
                                selectedTruckId &&
                                truckAttachments?.filter((item) => item?.documentType === "photo")
                            }
                            isEditable={isEditable}
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            maxLength={5}
                            showConfirmation
                            hideDeleteAllButton
                        />
                        {renderObjection("Truck Photo")}
                        {getCurrentUserRole[0] === "reviewer" &&
                            isQARole &&
                            truckAttachments?.filter((item) => item?.documentType === "photo")
                                ?.length > 0 && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("truckPhoto")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "truckPhoto",
                                            "Truck Photo",
                                            "License Info - Truck",
                                            "truck_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.truckPhoto?.verified
                                            ? objection?.truckPhoto?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.truckPhoto?.haveobjection
                                            ? objection?.truckPhoto?.haveobjection
                                            : false
                                    }
                                />
                            )}
                    </Row>
                    {objection?.truckPhoto?.haveobjection && (
                        <Textarea
                            required
                            autoFocus
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Truck Photo",
                                    "License Info - Truck",
                                    "truck_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
            <FormRow>
                <FormGroup>
                    <Row>
                        <UploadAttachments
                            label="Truck License Photo - Face"
                            onFilesChange={(e) =>
                                setNewTruckData({ ...newTruckData, licenseFace: e })
                            }
                            uploadedAttachments={
                                selectedTruckId &&
                                truckAttachments?.filter(
                                    (item) => item?.documentType === "license_face"
                                )
                            }
                            isEditable={isEditable}
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            maxLength={1}
                            required
                            showConfirmation
                        />
                        {renderObjection("Truck License Photo - Face")}
                        {getCurrentUserRole[0] === "reviewer" &&
                            isQARole &&
                            truckAttachments?.filter(
                                (item) => item?.documentType === "license_face"
                            )?.length > 0 && (
                                <VerifyComponent
                                    objectionHandler={() =>
                                        openObjectionhandler("licensePhotoFace")
                                    }
                                    handleVerify={() =>
                                        handleVerify(
                                            "licensePhotoFace",
                                            "Truck License Photo - Face",
                                            "License Info - Truck",
                                            "truck_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.licensePhotoFace?.verified
                                            ? objection?.licensePhotoFace?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.licensePhotoFace?.haveobjection
                                            ? objection?.licensePhotoFace?.haveobjection
                                            : false
                                    }
                                />
                            )}
                    </Row>
                    {objection?.licensePhotoFace?.haveobjection && (
                        <Textarea
                            required
                            autoFocus
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Truck License Photo - Face",
                                    "License Info - Truck",
                                    "truck_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>

                <FormGroup>
                    <Row>
                        <UploadAttachments
                            label="Truck License Photo - Back"
                            onFilesChange={(e) =>
                                setNewTruckData({ ...newTruckData, licenseBack: e })
                            }
                            isEditable={isEditable}
                            uploadedAttachments={
                                selectedTruckId &&
                                truckAttachments?.filter(
                                    (item) => item?.documentType === "license_back"
                                )
                            }
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            maxLength={1}
                            required
                            showConfirmation
                        />
                        {renderObjection("Truck License Photo - Back")}
                        {getCurrentUserRole[0] === "reviewer" &&
                            isQARole &&
                            truckAttachments?.filter(
                                (item) => item?.documentType === "license_back"
                            )?.length > 0 && (
                                <VerifyComponent
                                    objectionHandler={() =>
                                        openObjectionhandler("truckLicensePhotoBack")
                                    }
                                    handleVerify={() =>
                                        handleVerify(
                                            "truckLicensePhotoBack",
                                            "Truck License Photo - Back",
                                            "License Info - Truck",
                                            "truck_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.truckLicensePhotoBack?.verified
                                            ? objection?.truckLicensePhotoBack?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.truckLicensePhotoBack?.haveobjection
                                            ? objection?.truckLicensePhotoBack?.haveobjection
                                            : false
                                    }
                                />
                            )}
                    </Row>
                    {objection?.truckLicensePhotoBack?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Truck License Photo - Back",
                                    "License Info - Truck",
                                    "truck_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
            <FormRow>
                <FormGroup>
                    <Row>
                        <Input
                            type="date"
                            max={new Date(futureDate).toISOString().substring(0, 10)}
                            min={new Date(pastDate).toISOString().substring(0, 10)}
                            isEditable={isEditable}
                            required
                            placeholder="DD/MM/YYY"
                            label="License Expiration Date"
                            value={newTruckData?.licenseExpirationDate?.substring(0, 10)}
                            onChange={(e) =>
                                setNewTruckData({
                                    ...newTruckData,
                                    licenseExpirationDate: e.target.value,
                                })
                            }
                            errorMessage={licenseExpirationError}
                        />
                        {renderObjection("License Expiration Date")}
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() =>
                                    openObjectionhandler("licenseExpirationDate")
                                }
                                handleVerify={() =>
                                    handleVerify(
                                        "licenseExpirationDate",
                                        "License Expiration Date",
                                        "License Info - Truck",
                                        "truck_profile"
                                    )
                                }
                                verifed={
                                    objection?.licenseExpirationDate?.verified
                                        ? objection?.licenseExpirationDate?.verified
                                        : false
                                }
                                objection={
                                    objection?.licenseExpirationDate?.haveobjection
                                        ? objection?.licenseExpirationDate?.haveobjection
                                        : false
                                }
                            />
                        )}
                    </Row>
                    {objection?.licenseExpirationDate?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "License Expiration Date",
                                    "License Info - Truck",
                                    "truck_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
        </>
    );
}

export default LicenseInfo;
